<template>
    <div id="coinbase-payment-button" class="mx-2 my-1">
        <v-btn color="primary" :loading="loading" @click="createCharge">
            {{'Pay with Coinbase' | translation}}
        </v-btn>
    </div>
</template>

<script>
import {CoinbasePaymentType} from './config/coinbase-payment-type-config';
import module from './store/coinbasePayment';
import {mapState, mapMutations, mapActions} from 'vuex';

const moduleName = 'CoinbasePaymentType';

export default {
    name: moduleName,
    props: [
        'shippingAddress',
        'noButton',
    ],
    created() {
        this.loading = true;
        const transactionId = this.$route.query.transactionId;

        if (transactionId) {
            this.$router.replace({
                ...this.$route,
                query: {},
            }).then(() => {
                this.$emit('success', {transaction_id: transactionId});
            });
        }
    },
    computed: {
        ...mapState(moduleName, [
            'loading',
        ]),
    },
    beforeDestroy() {
        this.setError(null);
    },
    methods: {
        ...mapMutations(moduleName, [
            'setLoading',
        ]),
        ...mapMutations('Payment', [
            'setError',
        ]),
        ...mapActions(moduleName, [
            'createCharge',
            'getCharge',
        ]),
        ...mapActions(moduleName, {
            createChargeAction: 'createCharge',
        }),
        createCharge() {
            this.setLoading(true);
            this.$order.getOrder(true).then(order => {
                if (order && order.id) {
                    this.createChargeAction({
                        orderId: order.id,
                        transactionId: order.transaction_id,
                    })
                        .then(charge => {
                            window.location = charge.hosted_url;
                        });
                } else {
                    this.setError('Order not created, please try again later.');
                    this.setLoading(false);
                }
            });
        },
    },
    install(Vue) {
        if (!Vue.$store.state[moduleName]) {
            Vue.$store.registerModule(moduleName, module);
        }
        Vue.component(moduleName, this);
        Vue.$store.commit('Payment/addPaymentType', new CoinbasePaymentType());
    },
};
</script>
